import Text from "components/Text";
import styled from "styled-components";

export const GreyText = styled(Text)`
    font-size: 14px;
    font-weight: 600;
    color: #7b7187;
    margin-top: 2rem;
`;

export const FileInputWrapper = styled.div`
    display: flex;
    margin-top: 1rem;
    align-items: center;
    gap: 1rem;
`;

export const FileInputLabel = styled.label`
    background: #f3f0fd;
    color: #8868ea;
    border: none;
    padding: 12px 24px;
    border-radius: 6.25rem;
    cursor: pointer;
    font-weight: 600;
    &:hover {
        transition: 0.15s all ease-in-out;
        box-shadow: 0px 4px 14px rgba(136, 104, 234, 0.3);
    }
`;

export const Circle = styled.div<{ profileUrl: string }>`
    width: 100px;
    height: 100px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ profileUrl }) =>
        profileUrl ? `url(${profileUrl})` : "#d9d9d9"};
    background-size: cover;
    background-position: center;
`;

export const FileInput = styled.input`
    display: none;
`;
